/**
 * Deletion Audit Store - tracks what was cleaned up during permanent deletions
 */

const AUDIT_KEY = "khays_deletion_audit";

export interface DeletionAuditEntry {
  id: string;
  timestamp: number;
  itemType: "device" | "brand" | "category" | "grade";
  itemName: string;
  cleanedUp: string[]; // human-readable list of what was purged
}

function loadAudit(): DeletionAuditEntry[] {
  try {
    const s = localStorage.getItem(AUDIT_KEY);
    if (s) return JSON.parse(s);
  } catch {}
  return [];
}

function saveAudit(entries: DeletionAuditEntry[]): void {
  localStorage.setItem(AUDIT_KEY, JSON.stringify(entries));
}

export function addAuditEntry(entry: Omit<DeletionAuditEntry, "id" | "timestamp">): DeletionAuditEntry {
  const all = loadAudit();
  const newEntry: DeletionAuditEntry = {
    ...entry,
    id: `audit_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    timestamp: Date.now(),
  };
  all.unshift(newEntry);
  // Keep last 100 entries
  if (all.length > 100) all.length = 100;
  saveAudit(all);
  return newEntry;
}

export function getDeletionAuditLog(): DeletionAuditEntry[] {
  return loadAudit();
}

export function clearDeletionAudit(): void {
  localStorage.removeItem(AUDIT_KEY);
}
